import {Component, effect, inject} from '@angular/core';
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {LineChartModule} from "@swimlane/ngx-charts";
import {NgClass} from "@angular/common";
import {SpinnerComponent} from "src/app/presentation/common/spinner/spinner.component";
import {WaterPointSvgComponent} from "src/app/presentation/common/icons/water-point-svg/water-point-svg.component";
import {FixedSamplePoint, SynchronizationStatus} from "src/app/infrastructure/moovement-api/models/asset";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {ActionType, DataType} from "src/app/domain/domain-models";
import {CustomizableAssetComponent} from "src/app/presentation/common/customizable-asset.component";
import {InternalNotificationType} from 'src/app/infrastructure/internal-notifications/internal-notifications.store';
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';
import {parseOptionalFloat} from 'src/app/domain/util/parsing/parsing';

@Component({
  selector: 'app-customize-precipitation-sample-point',
  imports: [
    GenericButtonComponent,
    LineChartModule,
    SpinnerComponent,
    WaterPointSvgComponent,
    NgClass
  ],
  templateUrl: './customize-precipitation-sample-point.component.html',
  styleUrl: './customize-precipitation-sample-point.component.css'
})
export class CustomizePrecipitationSamplePointComponent extends CustomizableAssetComponent<FixedSamplePoint> {

  private fixedSamplePointsStore = inject(FixedSamplePointsStore);

  constructor(dataSynchronisationService: DataSynchronisationService, dataSubscriptionService: DataSubscriptionService, viewportService: ViewportService) {
    super(dataSynchronisationService, dataSubscriptionService, viewportService);

    effect(() => {
      const assetId = this.id();
      if (!assetId) return;

      this.asset.set(this.fixedSamplePointsStore.entityMap()[assetId]);
    });
  }

  setName($event: any): void {
    this.asset.update(asset => {
      if (!asset) return undefined;

      return {
        ...asset,
        name: $event.target.value
      }
    });
  }

  setLatitude($event: any): void {
    const latitude = parseOptionalFloat($event.target.value);
    this.updateLocation(latitude, this.asset()?.location?.coords?.[1]);
  }

  setLongitude($event: any) {
    const longitude = parseOptionalFloat($event.target.value);
    this.updateLocation(this.asset()?.location?.coords?.[0], longitude);
  }

  private updateLocation(latitude?: number, longitude?: number) {
    if (latitude === undefined || longitude === undefined) return;

    this.asset.update(asset => {
      if (!asset) return undefined;

      return {
        ...asset,
        location: {
          ...asset.location,
          coords: [latitude, longitude]
        }
      }
    });
  }

  protected override confirmDropAPinMessage(): string {
      return "Are you sure you want to change the location of this precipitation-sample point?";
  }

  override async applyChanges() {
    if (this.loading || !this.canBeAltered) return;

    await this.dataSynchronisationService.applyAction(
      DataType.precipitationSamplePoints,
      ActionType.mergeAsset,
      this.asset()!,
      SynchronizationStatus.syncPending
    );

    this.internalNotificationsStore.addNotification("Successfully altered precipitation point.", InternalNotificationType.SUCCESS, false);

    this.router.navigate(['/main/precipitation-sample-points']);
  }
}
